import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { incentiveBudgetsAdminRouter } from './routing/incentiveBudgetsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { incentiveBudgetsViewAccessControl } from './access-control/incentiveBudgetsAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'incentive-budgets',
  totem: {
    tool: 'incentive-budgets-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {},
  routers: {
    admin: [incentiveBudgetsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV3: AdminNavEntryPointV3.Fulfillment,
      subNavItems: [
        {
          route: 'app-admin-incentive-budgets-list',
          labelId: 'incentiveBudgetsDomain.nav.label',
          labelIdV3: 'incentiveBudgetsDomain.nav.label.v3',
          accessControl: incentiveBudgetsViewAccessControl,
        },
        {
          route: 'app-admin-incentive-budgets-events',
          labelId: 'incentiveBudgetsDomain.nav.events.label',
          labelIdV3: 'incentiveBudgetsDomain.nav.events.label.v3',
          accessControl: incentiveBudgetsViewAccessControl,
        },
      ],
    },
  ],
}

export default definition
